<template>
    <button class="btn btn-primary ml-md-2 add-button ml-4" @click="onClickHandler">
        <span
          class="png-icon png-icon-icons-glyph--ko-plus mr-2"
        />
        {{ buttonText }}
      </button>
</template>
<script>
export default{
  props:{
    onClickHandler:{
      type:Function,
      required: true,
    },
    buttonText: {
      type:String,
      required: true
    }
  },
}
</script>
